import React, { useEffect, useState } from "react";
import {
  IconUsers, IconHeadset, IconClock, IconArrowsExchange,
  IconChecks, IconClipboardList,
} from "@tabler/icons-react";
import BlockSection, { KPISubgroup } from "./BlockSection";
import KPICard from "./KPICard";
import InsightsChart from "./InsightsChart";
import { fetchTeam, exportInsightsXLSX } from "../services";

const TeamBlock = ({ filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const d = await fetchTeam(filters);
      setData(d);
    } catch (e) {
      setError("Não foi possível carregar este bloco.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-line */ }, [filters]);

  const k = data?.kpis || {};
  const ranking = data?.tables?.attendant_ranking || [];
  const distribution = data?.charts?.sessions_status_distribution;
  const daily = data?.charts?.sessions_daily;
  const hasData = data?.metadata?.has_data;

  // Esconde bloco inteiro se não há nenhum dado de time no período
  const hideBlock = !loading && !error && data && !hasData;

  return (
    <BlockSection
      title="Meu time está dando conta?"
      subtitle="Capacidade humana de atendimento e atividades"
      icon={IconHeadset}
      color="linear-gradient(135deg, #6f42c1, #a855f7)"
      loading={loading}
      error={error}
      onRetry={load}
      onExport={() => exportInsightsXLSX("team", filters)}
      hidden={hideBlock}
    >
<KPISubgroup title="Atendimento Humano" icon={IconHeadset} color="#6f42c1">
        <KPICard
          label="Sessões de Atendimento"
          kpi={k.sessions_total}
          icon={IconUsers}
        />
        <KPICard
          label="Finalizadas"
          kpi={k.sessions_finished}
          icon={IconChecks}
          color="linear-gradient(135deg, #16a34a, #15803d)"
        />
        <KPICard
          label="Abandonadas"
          kpi={k.sessions_abandoned}
          icon={IconUsers}
          color="linear-gradient(135deg, #f59e0b, #d97706)"
        />
        <KPICard
          label="Transferidas"
          kpi={k.sessions_transferred}
          icon={IconArrowsExchange}
        />
        <KPICard
          label="Duração Média"
          kpi={k.avg_duration_seconds}
          icon={IconClock}
          hint="Tempo médio por sessão finalizada"
        />
      </KPISubgroup>

      <KPISubgroup title="Atividades do CRM" icon={IconClipboardList} color="#a855f7">
        <KPICard
          label="Atividades Concluídas"
          kpi={k.activities_done}
          icon={IconChecks}
        />
        <KPICard
          label="Atividades Pendentes"
          kpi={k.activities_pending}
          icon={IconClock}
        />
        <KPICard
          label="Atividades Atrasadas"
          kpi={k.activities_overdue}
          icon={IconClock}
          color="linear-gradient(135deg, #ef4444, #dc2626)"
        />
      </KPISubgroup>

      <div className="insights-charts-row">
        {distribution?.series?.length > 0 && (
          <div className="insights-chart">
            <div className="insights-chart__head"><h3>Status das sessões</h3></div>
            <InsightsChart
              type="donut"
              labels={distribution.labels || []}
              series={distribution.series || []}
              colors={["#16a34a", "#137ff7", "#f59e0b", "#94a3b8"]}
            />
          </div>
        )}
        {daily?.series?.[0]?.data?.length > 0 && (
          <div className="insights-chart insights-chart--wide">
            <div className="insights-chart__head"><h3>Sessões iniciadas por dia</h3></div>
            <InsightsChart
              type="bar"
              categories={daily.categories || []}
              series={daily.series || []}
              colors={["#a855f7"]}
            />
          </div>
        )}
      </div>

      {ranking.length > 0 && (
        <div className="insights-table">
          <h3 className="insights-table__title">Ranking de atendentes</h3>
          <table>
            <thead>
              <tr>
                <th>Atendente</th>
                <th>Sessões</th>
                <th>Finalizadas</th>
                <th>Transferidas</th>
                <th>Abandonadas</th>
                <th>Taxa Transferência</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map((r) => (
                <tr key={r.attendant_id}>
                  <td>{r.name}</td>
                  <td>{r.sessions}</td>
                  <td>{r.finished}</td>
                  <td>{r.transferred}</td>
                  <td>{r.abandoned}</td>
                  <td>{r.transfer_rate}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </BlockSection>
  );
};

export default TeamBlock;
